import { render, staticRenderFns } from "./TournamentEdit.vue?vue&type=template&id=1d31f06c&scoped=true&"
import script from "./TournamentEdit.vue?vue&type=script&lang=js&"
export * from "./TournamentEdit.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TournamentEdit.vue?vue&type=style&index=1&id=1d31f06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31f06c",
  null
  
)

export default component.exports